var avatarColors = [
  '#2f6f9f',
  '#287d6a',
  '#5b4b8a',
  '#9a5b22',
  '#8a3f5d',
  '#356859',
  '#4f5d75',
  '#5c6ac4',
]

var funciones = {
  jsonToArray (json) {
    var result = []
    var keys = Object.keys(json)
    keys.forEach(function (key) {
      result.push(json[key])
    })
    return result
  },
  selectArrayItemById (array, valor) {
    var select = null
    array.forEach((item) => {
      if (typeof (valor) === 'string') {
        if (item.id.toString() === valor) {
          select = item
        }
      } else {
        if (item.id === valor) {
          select = item
        }
      }
    })
    return select
  },
  selectArrayItemByField (array, valor, field) {
    var select = null
    array.forEach((item) => {
      if (typeof (valor) === 'string') {
        if (item[field].toString() === valor) {
          select = item
        }
      } else {
        if (item[field] === valor) {
          select = item
        }
      }
    })
    return select
  },
  observerToArray (observer) {
    var result = []
    for (let i = 0; i < observer.length; i += 1) {
      if (typeof (observer[i]) === 'object') {
        try {
          result[i] = JSON.parse(JSON.stringify(observer[i]));
        } catch (e) {
          console.error(e);
        }
      }
    }
    return result
  },
  groupJSON(array, group, prop) {
    var nuevoArray    = []
    var arrayTemporal = []
    for(var i=0; i<array.length; i++) {   
      if(prop) {
        arrayTemporal = nuevoArray.filter(resp => resp["reference"] == array[i][group][prop])
      } else {
        arrayTemporal = nuevoArray.filter(resp => resp["reference"] == array[i][group])
      }        

      if(arrayTemporal.length>0){
          nuevoArray[nuevoArray.indexOf(arrayTemporal[0])]["group"].push(
            array[i]
          )
      }else{
          nuevoArray.push({
            "reference" : array[i][group][prop], 
            'data': array[i][group],
            "group" : [array[i]]
          })
      }      
    }
  
    return nuevoArray
  },
  groupBy(array, f) {
    const groups = {};
    array.forEach((o) => {
      const group = JSON.stringify(f(o));
      groups[group] = groups[group] || [];
      groups[group].push(o);
    })
    return Object.keys(groups).map((group) => {
      return groups[group];
    });
  },
  sortArrayDate(data, key, orden) {
    if (orden!=-1 && orden!=1) orden=1;
    data.sort(function(a,b){
      var dateA=new Date(a[key]),dateB=new Date(b[key]);
      return (dateA-dateB)*orden;
    })  
  },
  sortArrayInteger(data, key, orden) {    
    if (orden!=-1 && orden!=1) orden=1;
    data.sort(function(a,b){      
      var intA=a[key],intB=b[key];
      return (intA-intB)*orden;
    }) 
    return data 
  },  
  sortArrayIntegerMultiField(data, keys, orden) {    
    if (orden!=-1 && orden!=1) orden=1;
    data.sort(function(a,b){      
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const valA = a[key];
        const valB = b[key];
  
        if (valA !== valB) {
          return (valA - valB) * orden;
        }
      }
      return 0;
    }) 
    return data 
  },    
  sortArrayString(data, key, orden) {        
    if (orden!=-1 && orden!=1) orden=1;

    if(orden == 1) {
      data.sort(function(a, b){
        var nameA=a[key].toLowerCase(), nameB=b[key].toLowerCase();      
        if (nameA < nameB) //sort string ascending
          return -1;
        if (nameA > nameB)
          return 1;
        return 0; //default return value (no sorting)
      });
    } 
    if(orden == -1) {
      data.sort(function(a, b){
        var nameA=a[key].toLowerCase(), nameB=b[key].toLowerCase();      
        if (nameA > nameB)
          return -1;
        if (nameA < nameB)
          return 1;
        return 0; 
      });      
    }
    return data
  },
  invertColor(hex) {
    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    // invert color components
    var r = (255 - parseInt(hex.slice(0, 2), 16)).toString(16),
        g = (255 - parseInt(hex.slice(2, 4), 16)).toString(16),
        b = (255 - parseInt(hex.slice(4, 6), 16)).toString(16);
    // pad each with zeros and return
    return '#' + this.padZero(r) + this.padZero(g) + this.padZero(b);
  },    
  padZero(str, len) {
    len = len || 2;
    var zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
  },
  avatarFromName(name, customColors) {
    var normalizedName = String(name || '').trim()
    var identity = normalizedName.toLowerCase() || 'usuario'
    var colors = Array.isArray(customColors) && customColors.length
      ? customColors
      : avatarColors
    var hash = 0

    for (var index = 0; index < identity.length; index++) {
      hash = ((hash * 31) + identity.charCodeAt(index)) >>> 0
    }

    var backgroundColor = colors[hash % colors.length]

    return {
      text: normalizedName ? normalizedName.charAt(0).toUpperCase() : '?',
      backgroundColor: backgroundColor,
      style: {
        backgroundColor: backgroundColor,
        color: '#ffffff',
      },
    }
  },
  slugify (text, ampersand = 'and') {
    const a = 'àáäâèéëêìíïîòóöôùúüûñçßÿỳýœæŕśńṕẃǵǹḿǘẍźḧ'
    const b = 'aaaaeeeeiiiioooouuuuncsyyyoarsnpwgnmuxzh'
    const p = new RegExp(a.split('').join('|'), 'g')

    return text.toString().toLowerCase()
      .replace(/[\s_]+/g, '-')
      .replace(p, c =>
        b.charAt(a.indexOf(c)))
      .replace(/&/g, `-${ampersand}-`)
      .replace(/[^\w-]+/g, '')
      .replace(/--+/g, '-')
      .replace(/^-+|-+$/g, '')
  },   
  
  exportToCSV (arrayOfObjects, downloadName) {
    if (!arrayOfObjects.length) {
      return;
    }

    var lines = [];

    // headers
    lines.push(Object.keys(arrayOfObjects[0]).join(';'));

    // rows
    for (var i = 0; i < arrayOfObjects.length; i++) {
      var values = Object.values(arrayOfObjects[i]);
      for (var j = 0; j < values.length; j++) {
        var val = values[j];
        values[j] = (val === null || val === undefined) ? '' : String(val).replace(/#/g, '');
      }
      lines.push(values.join(';'));
    }

    var csvString = lines.join('\r\n');
    var blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    var url = URL.createObjectURL(blob);

    var link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', downloadName + '.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  },
  objectToCSVRow (dataObject) {
    var values = Object.values(dataObject);
    for (var i = 0; i < values.length; i++) {
      var val = values[i];
      values[i] = (val === null || val === undefined) ? '' : String(val).replace(/#/g, '');
    }
    return values.join(';') + '\r\n';
  },
  toFixed(value, precision) {
    return parseFloat(parseFloat(value).toFixed(precision))
  },

  // Importes a centavos enteros: evita falsos positivos por ruido de float
  // (ej: 2655865.5300000004 vs 2655865.53).
  toCents(value) {
    return Math.round((parseFloat(value) || 0) * 100)
  },

  // Compara dos importes a nivel centavos. Devuelve -1 (a<b), 0 (a==b) o 1 (a>b).
  // Usar en vez de comparar montos con ==, >, < directamente.
  compareMoney(a, b) {
    var ca = Math.round((parseFloat(a) || 0) * 100)
    var cb = Math.round((parseFloat(b) || 0) * 100)
    return ca === cb ? 0 : (ca > cb ? 1 : -1)
  },

  validarCUIT(cuit) {
    // Eliminar todos los caracteres que no sean números
    cuit = cuit.replace(/\D/g, '');

    // Verificar que el CUIT tenga 11 dígitos
    if (cuit.length !== 11) {
        return false;
    }

    // Verificar prefijo válido (20, 23, 24, 27, 30 o 33)
    const prefijo = parseInt(cuit.substring(0, 2));
    if (![20, 23, 24, 27, 30, 33].includes(prefijo)) {
        return false;
    }

    // Coeficientes para el cálculo del dígito verificador
    const coeficientes = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

    // Obtener los primeros 10 dígitos y el dígito verificador
    const digitos = cuit.split('').map(Number);
    const digitoVerificador = digitos.pop(); // Último dígito

    // Calcular la suma ponderada
    let suma = 0;
    for (let i = 0; i < coeficientes.length; i++) {
        suma += digitos[i] * coeficientes[i];
    }

    // Calcular el dígito verificador esperado
    const resto = suma % 11;
    let digitoEsperado = 11 - resto;
    if (digitoEsperado === 11) digitoEsperado = 0;
    if (digitoEsperado === 10) digitoEsperado = 9;

    // Comparar el dígito verificador con el esperado
    return digitoVerificador === digitoEsperado;
  },

  // Deja solo dígitos. Si ya trae código de país, saca el "9" de móvil
  // después del 54 (549... -> 54...), porque la Cloud API de WhatsApp lo
  // rechaza aunque esté verificado como destinatario. Si NO trae código de
  // país (10 u 11 dígitos), se asume Argentina y se le agrega el 54.
  normalizarTelefonoWhatsapp(telefono) {
    var nro = String(telefono || '').replace(/\D/g, '')

    if (nro.substring(0, 2) === '54') {
      if (nro.substring(0, 3) === '549') {
        nro = '54' + nro.substring(3)
      }
      return nro
    }

    if (nro.substring(0, 1) === '9') {
      nro = nro.substring(1)
    }
    return '54' + nro
  },

  // Válido con código de país (12 u 13 dígitos, con o sin el 9 de móvil) o
  // sin código de país (10 u 11 dígitos) asumiendo Argentina.
  validarTelefonoWhatsapp(telefono) {
    var nro = String(telefono || '').replace(/\D/g, '')

    if (nro.substring(0, 2) === '54') {
      return nro.length === 12 || nro.length === 13
    }

    return nro.length === 10 || nro.length === 11
  }
}

export default funciones
